var index = (function () {

    var mobile = false;
    var isIOS = false;
    var isAndroid = false;
    var isMobileOtros = false;



    var config = {};

    var templateItemResult = $.templates("#resultSearch");

    var URL_SEARCH_PRODUCTS = "/v2/job-installation/product/search";
    var URL_LOGIN_AJAX = "/ajaxLogin";
    var ITEMS_SEARCH_BY_SLIDE = 9;

    function isMobile() {
        return MarbV2.Commons.Util.isMobile();
    }

    function bindearSelectOptions() {
        $("#ifix-selectInstallHome-button").on("click", function () {
            window.location.href = $("#selectInstallHome").val();
        });

        $("#ifix-selectInstallCar-button").on("click", function () {
            window.location.href = $("#selectInstallCar").val();
        });
    }

    function initComponents(opt) {
        mobile = isMobile();
        
        if (!mobile){
            updateHeaderColor();
        	$(window).scroll(function () {
                updateHeaderColor();
            });
        } else {
        	if (isIOS){
        		$('#ifix-badges-app').attr("href", opt.appIOS);
                $('#ifix-badges-app img').attr("src", opt.cdnUrl + 'static/v2/images/home/badge-app-store_' + opt.language + '.svg');
        	} else {
        		$('#ifix-badges-app').attr("href", opt.appAndroid);
                $('#ifix-badges-app img').attr("src", opt.cdnUrl + 'static/v2/images/home/badge-google-play_' + opt.language + '.svg');
        	}
        }
        bindearSelectOptions();
        
        $(".scroll-icon").click(function(){
        	var target = $(this.hash);
        	target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        	if (target.length) {
                $('html,body').animate({
                	scrollTop: target.offset().top - $("#main-header").height()
                }, 800);
                return false;
            }

            event.stopPropagation();
        });
    }

    function initFullPage() {
        if ( !mobile ) {
    		var scroll = $(window).scrollTop();
    		var s = $('.primary-section').height();
    		
    		if (scroll > s) {
    			$('.main-header').css('background-color', 'rgba(53, 81, 173, 1)');
    		}
            $("#ifix-carousel-howitworks").carousel({interval: false});
    		$("#ifix-companies-cases-carousel").carousel({interval: false}); //for companies
        } else {
            $("#ifix-carousel-howitworks").carousel({interval: false});
    		$("#ifix-companies-cases-carousel").carousel({interval: false});//for companies
    		var h = $(window).height();
    		$(".section-home .container-fluid").height(h);
    		if (isIOS){
    			$("#section0").css("background-attachment", "initial");
    		}

        }
    }
    
    function initNavMobile(){
    	$('#mobile-nav-trigger').on('click', function (e) {
    		e.stopPropagation();
            $('#mobile-nav-trigger').toggleClass('active');
            $('#mobile-nav').toggleClass('mobile-nav-open');
            $('body').toggleClass('overf-y-hidden');
        });
    }
    
    function initNavDesktop() {
    	$('#login-content, #login-trigger, #nav-account-trigger, #account-content, .mobile-nav-wrap').on('click', function(e){
    		e.stopPropagation();
    	});
    	
    	$('#login-trigger').on("click", function(e){
    		e.stopPropagation();
    		e.preventDefault();

            if (!$('#login-content').is(':visible')){
                setTimeout(function (){
                    $("#j_username").focus();
                }, 400);
            }

            $('#login-content').slideToggle(200);
            $(this).toggleClass('active');

    	});

    	$('#nav-account-trigger').on("mouseover", function(e){
    		e.stopPropagation();
    		e.preventDefault();
    		if (!$('#account-content').is(':visible')){
    			$(this).next('#account-content').slideToggle();
    			$(this).toggleClass('active');          
    		}
    	});
    	
    	$('#ifix-form-login').on("submit", function(e){
    		e.preventDefault();
    		var username = $('#j_username').val();
    		var password = $('#j_password').val();
    		post(URL_LOGIN_AJAX, {j_username: username, j_password: password}, function (response){
                if (response.success) {
                    if (response.data.redirectUrl) {
                        window.location.href = response.data.redirectUrl;
                    } else {
                        window.location.reload();
                    }
                } else {
    			    if(response.errorElements && response.errorElements.invalidDomain){
                        $('#j_password').addClass('invalid invalid-domain');
                    } else {
                        $('#j_password').addClass('invalid generic-error');
                    }
                }
    		});
    	});

        initSearcher();
    	
    	$(window).on("click touch touchstart",function(event) {
    		if ($('#login-content').is(':visible')){
    			$('#login-content').slideToggle();
                $('#login-trigger').toggleClass('active');
    		}
    		if ($('#account-content').is(':visible')){
    			$('#account-content').slideToggle();
    		}
            
            if ($('.mobile-nav-wrap').is(":visible") &&
                $(event.target).closest('.mobile-nav-wrap').length == 0 &&
                $('#mobile-nav').hasClass('mobile-nav-open')) {
                    $('#mobile-nav-trigger').toggleClass('active');
                    $('#mobile-nav').toggleClass('mobile-nav-open');
                    $('body').toggleClass('overf-y-hidden');
            }
    	});
    	
    }


    function initSearcher() {
        var $inputSearch = $('#search-input');
        var $closeBtn = $('#search-full-page .close');
        var $searchBox = $('#search-full-page');
        var $searchButton = $('.search-full-button');

        $searchButton.on('click', function(event) {
            event.preventDefault();
            $('body').addClass('search-open');
            $searchBox.addClass('open box-shadow');
            $searchBox.find($inputSearch).focus();
        });

        $searchBox.on('click keyup', function(event) {
            event.preventDefault();
            if (event.target === this || event.keyCode === 27) {
                closeMainSearch();
            }
        });

        $closeBtn.on('click touch', function(event) {
            event.preventDefault();
            closeMainSearch();
        });

        function closeMainSearch() {
            $searchBox.removeClass('open');
            $('body').removeClass('search-open');
        }

        $inputSearch.autocomplete({
            delay: 200,
            minLength: 3,
            source: function (request, response) {
                $('#search-full-page').find('.preloaderContent').toggleClass('hidden');
                $('#categories-filter').hide();
                $.fn.getJson(URL_SEARCH_PRODUCTS + "?term=" + request.term + "&country=" + config.country, function (resultView){
                    updateSearchResults(resultView, response);
                });
            },
            search: function () {
                var searchResults = $('.search-results');
                var categoriesFilter = $('#categories-filter');

                if (searchResults.hasClass('slick-slider')) {
                    searchResults.slick('unslick');
                }
                searchResults.removeClass('animated fadeIn');
                searchResults.empty();
                searchResults.html($('<div>', {'class': 'result-container'}));

                if (mobile && categoriesFilter.hasClass('slick-slider')) {
                    categoriesFilter.slick('unslick');
                }
            },
            select: function (event, ui){
                $(this).val(ui.item.label);
            },
            create: function () {
                $(this).data("ui-autocomplete")._renderItem = function( ul, item ) {
                    var containers = $('.search-results').find('.result-container');
                    var lastContainer = $(containers[containers.length - 1]);
                    if (lastContainer.find('.result-container-item').length == getItemsSearchBySlide()) {
                        lastContainer = $('<div>', {'class': 'result-container'});
                        lastContainer.appendTo('.search-results');
                    }

                    $('.search-results').addClass('animated fadeIn');

                    var itemResult = $("<div>",
                        { 'id' : 'itemresult-' + item.value.id, 'class': 'col-md-4 col-xs-12 result-container-item'});
                    itemResult.appendTo(lastContainer);
                    var htmlOutput = templateItemResult.render(item.value);
                    $("#itemresult-"+ item.value.id).html(htmlOutput);
                    return itemResult;
                };
                $(this).data("ui-autocomplete")._renderMenu = function (ul, items) {
                    var that = this;
                    $.each( items, function( index, item ) {
                        that._renderItemData( ul, item );
                    });
                    if (!mobile) {
                        $('.search-results').slick({
                            slidesToShow: 1,
                            dots: true,
                            infinite: false
                        });
                    }
                    if (mobile) {
                        $("#categories-filter").slick({
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            dots: false,
                            centerMode: true,
                            infinite: false,
                            variableWidth: true
                        });
                    }
                };
            }
        });
    }

    function getItemsSearchBySlide(){
        if (mobile) {
            return 50;
        }
        return ITEMS_SEARCH_BY_SLIDE;
    }

    function initFooterAccordion(){
        $('.ifix-list-widget-title').on('click',function(){
            if (mobile) {
                $(this).find('.fa').toggleClass('fa-plus-circle');
                $(this).find('.fa').toggleClass('fa-minus-circle');
            }
        });
        updateFooter();
    }

    function updateFooter(){
        if (mobile) {
            $('.ifix-list-widget-title').each(function(){
                if(!$(this).attr('data-toggle')){
                    $(this).attr('data-toggle','collapse'); 
                    $('.ifix-list-widget').addClass('collapse');
                }
            });
        }else {
            $('.ifix-list-widget-title').each(function(){
                if($(this).attr('data-toggle')){
                    var ifixListWidget = $('.ifix-list-widget');
                    $(this).removeAttr('data-toggle');
                    ifixListWidget.removeClass('collapse');
                    ifixListWidget.removeAttr('aria-expanded');
                    ifixListWidget.removeAttr('style');
                }
            });
        }
    }

    function updateHeaderColor(){
        var h = $('.main-header').height();
        var scroll = $(window).scrollTop();
        var s = $('.primary-section').height();
        if(s !== undefined) {
            if (scroll > s) {
                $('.main-header').css('background-color', 'rgba(53, 81, 173, 1)');
            } else {
                if (scroll === 0) {
                    $('.main-header').css('background-color', 'rgba(53, 81, 173, 0)');
                } else {
                    $('.main-header').css('background-color', 'rgba(53, 81, 173, ' + (h + scroll) / s + ')');
                    $('.ifix-home-container').css('opacity', 1 - (h + scroll) / s);
                }
            }
        }
    }

    function updateSearchResults(resultsView, response) {
    	var resultsSearch = [],
            notFoundMessage = $("#search-full-page .form p"),
            segmentSearch = $("#segment-search"),
            categoriesFilter = $("#categories-filter");

        resultsView.products.forEach(function (product){
    		resultsSearch.push({label: product.description, value: product});
    	});

        categoriesFilter.empty();
        if (resultsSearch.length == 0) {
            notFoundMessage.slideDown('slow');
            segmentSearch.show();
        } else {
            notFoundMessage.slideUp("slow");
            segmentSearch.hide();

            resultsView.categories.forEach(function (category) {
                categoriesFilter.append(
                    $('<div>', {'class': 'search-buttons-item'}).append(
                        $('<a>',{'text': category.name, 'href': category.webLink, 'class': 'btn btn-search-cats hoverable'})
                            .append($('<span>', {'class': 'anim'}))
                    )
                );
            });
        }
        response(resultsSearch);
        $('#search-full-page').find('.preloaderContent').toggleClass('hidden');
        categoriesFilter.show();
    }
    

    
    function post(url, data, callback){
    	return $.ajax({
    		url: url,
    		type: 'POST',
            data: data,
            dataType: 'json',
            success: callback
    	});
    }

    function init(options) {
    	config = options;
        
        new WOW().init();
        
        initComponents(options);
        initFullPage();
        initNavMobile();
        initNavDesktop();
        initFooterAccordion();

        $("#status").fadeOut();
        $("#preloader").delay(500).fadeOut('slow');

        $( window ).resize(function() {
            initComponents(options);
            initFullPage();
            updateFooter();
        });
    }

    return {
        init: init,
        isMobile: isMobile
    };
    
})();

var setFormValue = {};
var needJumpSteps = {};
var previousSelectedNeedJumpSteps = {};
var Landing = (function () {
    var config = {};

    function init(options) {
    	config = options;
    }
    
    function getCalendarAvailability() {
    	return config.INSTALLATION_CALENDAR;
    }
    
    function getCurrentLocale(){
    	return config.locale;
    }

    return {
        init: init,
        getCalendarAvailability: getCalendarAvailability,
        getCurrentLocale: getCurrentLocale
    };
})();